var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-quotes-table-header"},[_c('div',[_vm._v("Quote #")]),_c('div',[_vm._v("Quote total")]),_c('div',[_vm._v("Date generated")]),_c('div',[_vm._v("Expiration date")]),_c('div',[_vm._v("Status")]),_c('div')])
}]

export { render, staticRenderFns }